define(["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.registerDefinition = registerDefinition;
  _exports.definitionMap = void 0;
  // @ts-check

  /** @type {Record<string, HTMLElement[]>} */
  const definitionMap = Object.create(null);
  /**
   * @param {HTMLElement} dfn A definition element to register
   * @param {string[]} names Names to register the element by
   */

  _exports.definitionMap = definitionMap;

  function registerDefinition(dfn, names) {
    for (const name of names.map(name => name.toLowerCase())) {
      if (name in definitionMap === false) {
        definitionMap[name] = [dfn];
      } else if (!definitionMap[name].includes(dfn)) {
        definitionMap[name].push(dfn);
      }
    }
  }
});
//# sourceMappingURL=dfn-map.js.map